module.exports = __webpack_public_path__ + "static/media/panel_color.1ca9ed5c.png";